import { Injectable } from "@angular/core";
import { ContextualHelpModel } from "../models/contextualHelp";
import { HttpClient } from "@angular/common/http";
import { EndpointsService } from "./endpoints.service";
import { cloneDeep } from "lodash";
import { UiBlockService } from "./ui-block.service";
import { ModalControlService } from "./modal-control.service";

import { firstValueFrom } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ContextualHelpService{

  contextualHelpToolTips : ContextualHelpModel[] = [];
  public static readonly UNAVAILABLE_OPTION = "We're currently working on this feature and will notify you as soon as it's available. Thank you for your patience!";

  private loadAllPromise: Promise<void> | null = null; // guarantees GET-all only once

  constructor(public http: HttpClient,
    public endpointService: EndpointsService,
    public uiBlock: UiBlockService,
    public modalControlService: ModalControlService
    ){
    }



    async loadAllOnce(): Promise<void> {
    if (this.loadAllPromise) return this.loadAllPromise;
    this.loadAllPromise = (async () => {
      const all = await firstValueFrom(
        this.http.get<ContextualHelpModel[]>(
          this.endpointService.contextualHelpGetAll,
          this.endpointService.httpOptions
        )
      );
      // for safety, remove duplicates based on functionality name
      const seen = new Set<string>();
      this.contextualHelpToolTips = all.filter((it) => {
        const key = it.functionality?.toLowerCase?.() ?? '';
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    })();
    return this.loadAllPromise;
  }

  /** Ensures that a record exists for a functionality; creates a default one and persists if missing */
  async ensureExists(label: string): Promise<ContextualHelpModel> {
    await this.loadAllOnce();

    const existing = this.contextualHelpToolTips.find(
      (c) => c.functionality?.toLowerCase() === label.toLowerCase()
    );
    if (existing) return existing;

    // Creates a default record if it doesn't exist
    const created: ContextualHelpModel = {
      functionality: label,
      isEnabled: true,
      descriptionText: "",
      linkName: "",
      link: "",
      selected: false

    } as ContextualHelpModel;

    // Save the new record
    this.http.get(this.endpointService.contextualHelpGet + '/' + label + '/' + true, this.endpointService.httpOptions)
      .subscribe((contextHelp: ContextualHelpModel) => {
        this.contextualHelpToolTips.push(contextHelp);
      });
    return created;
  }

  save(){
    this.uiBlock.startBlock("Saving Changes");
    this.http.post(this.endpointService.contextualHelpUpdate,
      this.contextualHelpToolTips,
      this.endpointService.httpOptions
    ).subscribe((result:ContextualHelpModel[]) =>{
      this.contextualHelpToolTips = cloneDeep(result);
      this.uiBlock.stopBlock();
      this.modalControlService.showMesssageModal("Contextual Help", "Changes saved successfully");
    })
  }

  isMenuOptionEnabled(label:string){
    const contextualHelpModel = this.contextualHelpToolTips
    .find((contextualHelp:ContextualHelpModel)=> contextualHelp.functionality.toLowerCase()  == label.toLowerCase())
    return (contextualHelpModel?.isEnabled===true) || contextualHelpModel?.functionality == 'Contextual Help'
  }



}
